import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import DataLoader from "../../../../ui/template/Data/DataLoader";
import Child from "../../../../ui/template/Children/Child";
import AppConfig from "../../../Controllers/AppConfig";
import ShowProfile from "../../../Controllers/Dashboard/ShowProfile";
import ShowInvertFriend from "../../Friend/Controllers/ShowInvertFriend";
import Fancybox from "../../../../ui/template/Image/Fancybox";


class   Gallerys extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HfunCV=this.funCV.bind(this);
        this.props=props;
    }

    funCV(data,ts,recordKey,selectFun=null){
        let rows=[];
        let l=data.length;
        let s1=null;
        for (let i=0;i<l;i++){
            this.rowsId++;
            s1='http://mdyaran.ir/membership/gallery/'+data[i].id+'.'+data[i].fileType;
            let el=  <div key={this.rowsId} className="col col-12 col-sm-12 col-md-6 col-lg-4 px-2">
                <a  href="javascript:void(0)"  data-fancybox="gallery"  data-src={s1}
                    className="button button--secondary gallery-item" >
                    <img className="lazyload blur-up img-fluid box shadow-sm border rounded mb-3 "
                         data-src={s1}   src="/images/default.png" alt="" /></a>
                    </div>    ;
            rows.push(el);
        }
        ts.cv=<> <div className="row mb-3">{rows}</div></>;
    }


    componentDidMount(){
        let page = this.context.page;
        this.context.page.pageTitle.setTitle(" گالری تصاویر ");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.loaded) {
            if (this.context.page.pageBreadcrumbs.current != null) {
                this.context.page.pageBreadcrumbs.current.setCurrent("galleri");
                this.context.page.pageBreadcrumbs.current.show();
            }
        }
    }

   

    render() {

        return (
            <div className="row">
                <aside  className="col col-xl-3 order-xl-1 col-lg-6 order-lg-2 col-md-6 col-sm-12 col-12 side-sticky">
                    <ShowProfile  />
                    <ShowInvertFriend />
                </aside>
                <main className="col col-xl-9 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-12 col-12">
                    <Fancybox options={{ infinite: false }}>
                        <DataLoader ref={this.table1} scope="route" name="gallery" classNameLoader="dataloader3"
                                    baseUrl={AppConfig.base_url} orderColumn={1} orderDir={2} lengthTable={9}
                                    srcName="gallery" getBoxItem={ this.HgetBoxItem} selectable={false}
                                    funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className="" isHeader={false}
                                    queryFields="id,title,fileType">
                            <Child type="navbar">

                            </Child>
                            <Child type="links">

                            </Child>
                        </DataLoader>
                    </Fancybox>
                </main>
            </div>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Gallerys.contextType = MCbrowser;

export default Gallerys;
